@if (show()) {
    @if (spidEnabled()) {
        <div
            class="fixed bottom-0 flex w-full flex-col items-stretch gap-12 bg-surface-A px-20 pt-20 pb-16 shadow-md sm:flex-row sm:items-center"
        >
            <p class="grow typo-sm">
                {{ 'MOBILE_TIP.SPID_MESSAGE' | translate }}
            </p>
            <div class="flex shrink-0 flex-row justify-end">
                <button
                    interacta-button
                    type="button"
                    [label]="'UI.BUTTON.CLOSE' | translate"
                    [size]="'small'"
                    [style]="'text'"
                    (click)="dismiss()"
                ></button>
            </div>
        </div>
    } @else {
        <div
            class="fixed bottom-0 flex w-full flex-col items-stretch gap-12 bg-surface-A px-20 py-16 shadow-md sm:flex-row sm:items-center"
        >
            <div class="flex grow flex-col gap-4">
                <span class="typo-t6">
                    {{ 'MOBILE_TIP.TITLE' | translate }}
                </span>
                <p class="typo-sm">
                    {{ 'MOBILE_TIP.MESSAGE' | translate }}
                </p>
            </div>
            <div class="flex shrink-0 flex-row justify-end gap-8">
                @if (mobileAppService.storeUrl()) {
                    <a
                        interacta-button
                        target="_blank"
                        [href]="mobileAppService.storeUrl()"
                        [label]="'MOBILE_TIP.CTA' | translate"
                        [size]="'small'"
                        [style]="'tonal'"
                    ></a>
                }
                <button
                    interacta-button
                    type="button"
                    [label]="'UI.BUTTON.CLOSE' | translate"
                    [size]="'small'"
                    [style]="'text'"
                    (click)="dismiss()"
                ></button>
            </div>
        </div>
    }
}
